<template>
  <div
    class="bgPage min-height-for-section w-100 d-flex justify-content-center align-items-center"
  >
    <div class="container-fluid my-4" v-if="model">
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="w-100 header-container">
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <AvatarPopup ref="avatarPopupModal"></AvatarPopup>
                  <div
                    class=" w-100 mb-5 d-flex justify-content-center align-items-center text-gray text-left"
                  >
                    <div
                      style="width: 150px;height:150px;border-radius: 8px;border: 3px solid #dae12f;position: relative;overflow: hidden;"
                    >
                      <img
                        :src="profileImage"
                        alt="Select Profile Image"
                        class="w-100"
                        @error="imageLoadError($event)"
                      />
                      <div
                        style="position: absolute;right: 4px;bottom: 4px;cursor:pointer;"
                        @click="openModal()"
                      >
                        <div
                          style="background-color:#6c757d;border-radius: 4px;padding: 4px;width:24px;height: 24px;display: flex;justify-content: center;align-items: center;"
                        >
                          <img
                            src="../assets/editIcon.svg"
                            alt=""
                            style="width: 100%;"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="login-wrapper  p-md-4">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.name)"
                    >
                      <label class="w-100 inputLabelText">Nama</label>
                      <input
                        type="text"
                        name="name"
                        class="form-control"
                        required
                        v-model.lazy="model.name"
                      />

                      <field-messages
                        name="name"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required" class="error">
                          Sila masukkan nama anda
                        </div>
                      </field-messages>
                    </validate>

                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.email)"
                    >
                      <label class="w-100 inputLabelText">Emel</label>
                      <input
                        type="email"
                        name="email"
                        class="form-control"
                        disabled
                        v-model.lazy="model.email"
                      />

                      <field-messages
                        name="email"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required" class="error">
                          Sila masukkan e-mel anda
                        </div>
                      </field-messages>
                    </validate>

                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.gender)"
                    >
                      <label class="w-100 inputLabelText">Jantina</label>
                      <select
                        class="form-control"
                        id="genderselection"
                        name="gender"
                        v-model.lazy="model.data.gender.id"
                        required
                      >
                        <option
                          v-for="(genderType, index) in genderArr"
                          :key="index"
                          :value="genderType.id == 848 ? '' : genderType.id"
                          >{{ genderType.value.en_US }}</option
                        >
                      </select>
                      <field-messages
                        name="gender"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required" class="error">
                          Sila pilih jantina anda
                        </div>
                      </field-messages>
                    </validate>

                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(formstate.nationality)"
                    >
                      <label class="w-100 inputLabelText">Nationality</label>
                      <select
                        class="form-control"
                        id="nationalityselection"
                        name="nationality"
                        v-model.lazy="model.data.nationality.id"
                        required
                      >
                        <option
                          v-for="(nationalityType, index) in nationalityArr"
                          :key="index"
                          :value="
                            nationalityType.id == 851 ? '' : nationalityType.id
                          "
                          >{{ nationalityType.value.en_US }}</option
                        >
                      </select>

                      <field-messages
                        name="nationality"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required" class="error">
                          Sila nyatakan kewarganegaraan anda
                        </div>
                      </field-messages>
                    </validate>
                    <div class="w-100 my-2 error" v-if="errorMsg">
                      {{ errorMsg }}
                    </div>
                    <div class="w-100 my-2 success" v-if="successMsg">
                      Update successful.
                    </div>
                    <div class="w-100 d-flex flex-column py-2 text-center">
                      <button class="modal-default-button mb-2" type="submit">
                        Save
                      </button>
                      <button class="cancel-default-button" @click="goHome()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </vue-form>
                <div class="w-100 mt-3">
                  <router-link class="" :to="'/reset'">
                    <div class="w-100 d-flex flex-row justify-content-center">
                      <span class="ml-2 signup-text"
                        >Set semula kata laluan?</span
                      >
                    </div>
                  </router-link>
                </div>
                <div class="w-100 mt-2">
                  <!-- <div class="w-100 py-2" @click="removeAccount()">
                    <span class="ml-2 signup-text cursor-pointer">
                      Padam Akaun?
                    </span>
                  </div> -->
                  <button
                    type="button"
                    class="ml-2 signup-text cursor-pointer"
                    style="background: none;border: none;"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    Padam Akaun?
                  </button>

                  <!-- Modal -->
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel"></h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          Adakah anda ingin memadam akaun anda?
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Tidak
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary"
                            @click="removeAccount()"
                          >
                            Ya
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { bus } from "../main";
import axios from "axios";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import AvatarPopup from "../components/popup/avatarProfilePopup.vue";
import defaultAvatar from "../assets/defaultProfileImage.png";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BreadCrumbsHeader,
    AvatarPopup,
  },
  data() {
    return {
      formstate: {},
      userId: localStorage.getItem("user_id"),
      model: {
        name: "",
        data: {
          gender: {
            id: "",
          },
          nationality: {
            id: "",
          },
        },
      },
      genderArr: [],
      nationalityArr: [],
      errorMsg: "",
      successMsg: "",
      profileImage: "",
      avatarCookies: this.$cookie.get("avatar"),
    };
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        console.log("i");
      });
    },
    imageLoadError(event) {
      event.target.src = defaultAvatar;
    },
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    goHome() {
      this.$router.replace({
        name: "home_new",
      });
    },
    async removeAuthenticatedUser() {
      try {
        let res = await axios.delete(
          `https://rtm.glueapi.io/v1/authenticate?iframe=parseMessageeb3f40066388df5b59bad47b15294ffb&glueToken=${localStorage.getItem(
            "token"
          )}`,
          {
            headers: {
              "X-AUTH-TOKEN": localStorage.getItem("token"),
            },
          }
        );
        this.errorMsg = "";
        let data = res.data;
        this.successMsg = "Profil berjaya di padam";
        this.signOut();
      } catch (error) {
        // console.log(error); // this is the main part. Use the response property from the error object
        this.errorMsg = error.response.data.ResponseStatus.Message;
        this.successMsg = "";
        return error.response;
      }
    },
    async removeAccount() {
      try {
        let res = await axios.delete(
          `https://rtm.glueapi.io/v3/user/${this.userId}`,
          {
            headers: {
              "X-AUTH-TOKEN": localStorage.getItem("token"),
            },
          }
        );
        this.errorMsg = "";
        let data = res.data;

        if (data) {
          this.removeAuthenticatedUser();
        }

        return data;
      } catch (error) {
        // console.log(error); // this is the main part. Use the response property from the error object
        this.errorMsg = error.response.data.ResponseStatus.Message;
        this.successMsg = "";
        return error.response;
      }
    },
    onSubmit: function(e) {
      e.preventDefault();
    },
    async onSubmit(e) {
      e.preventDefault();

      if (
        this.model.name &&
        this.model.data.nationality.id &&
        this.model.data.gender.id
      ) {
        try {
          let res = await axios.put(
            `https://rtm.glueapi.io/v1/user/${this.userId}`,
            {
              name: this.model.name,
              data: {
                gender: this.model.data.gender.id,
                nationality: this.model.data.nationality.id,
              },
            },
            {
              headers: {
                "X-AUTH-TOKEN": localStorage.getItem("token"),
              },
            }
          );
          this.errorMsg = "";
          let data = res.data;
          this.successMsg = "Profil berjaya dikemaskini.";
          return data;
        } catch (error) {
          // console.log(error); // this is the main part. Use the response property from the error object
          this.errorMsg = error.response.data.ResponseStatus.Message;
          this.successMsg = "";
          return error.response;
        }
      }
    },
    async getGender() {
      let response = await axios.get(
        "https://rtm.glueapi.io/v1/content-list/4",
        {
          responseType: "json",
        }
      );

      this.genderArr = response.data.data.entries;
    },
    async getNationality() {
      let response = await axios.get(
        "https://rtm.glueapi.io/v1/content-list/2",
        {
          responseType: "json",
        }
      );

      this.nationalityArr = response.data.data.entries;
    },
    openModal() {
      this.$refs.avatarPopupModal.show();
    },
  },
  created() {
    // bus.$on("avatarChosen", (data) => {
    //   // console.log("bus on");
    // });
  },
  computed: {
    ...mapGetters("auth", {
      user: "user",
    }),
  },

  watch: {
    user: {
      handler(user) {
        if (user) {
          this.model = user;
          var avatarChanged = this.avatarCookies ? true : false;
          const getUserImage = this.model.userImage[0];

          if (getUserImage) {
            if (avatarChanged) {
              this.profileImage = `https://rtm-images.glueapi.io/320x320/${
                this.avatarCookies
              }`;
            } else {
              this.profileImage = `https://rtm-images.glueapi.io/320x320/${
                getUserImage.subDirectory
              }/${getUserImage.fileName}`;

              this.$cookie.set(
                "avatar",
                `${getUserImage.subDirectory}/${getUserImage.fileName}`,
                {
                  expires: "12h",
                }
              );
            }
          } else {
            this.profileImage = defaultAvatar;
          }

          const isGenderAvailable =
            this.model && this.model.data && this.model.data.gender;
          const isNationalityAvailable =
            this.model && this.model.data && this.model.data.nationality;
          if (!isGenderAvailable || !isNationalityAvailable) {
            this.model.data = {
              gender: {
                id: 848,
              },
              nationality: {
                id: 851,
              },
            };

            this.getGender();
            this.getNationality();
          } else {
            this.getGender();
            this.getNationality();
          }
        }
      },
      immediate: true,
    },
    avatarCookies: {
      handler() {},
    },
  },
};
</script>

<style scoped>
.min-height-for-section {
  min-height: 80vh;
  padding: 4rem 0;
}
.bgPage {
  background: url("../assets/rtmklik/bg-login-v2.png") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.icon-logo {
  width: 80px;
  height: 80px;
}

.header-container {
  max-width: 480px;
}
.header-text {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.header-desc {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  background: #171f26;
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06),
    0px 4px 8px -2px rgba(16, 24, 40, 0.1);
}
.inputLabelText {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}
.form-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  padding: 8px 14px;
  align-items: center;
}
.form-control:focus {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.modal-default-button {
  width: 100%;
  display: flex;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #d9e021;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  outline: none;
}

.signup-text {
  color: #d9e021;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  /* background: #111319; */
  border-radius: 4px;
}
.text-yellow {
  color: #dae12f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 14px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.form-control:disabled {
  background-color: #111319;
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 14px;
  margin-top: 4px;
}
.modal-default-button {
  background: #dae12f;
  color: #000000 !important;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
.cancel-default-button {
  background: #111319;
  color: #ffffff;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
@media screen and (max-width: 768px) {
  /* .pt-livetv {
    padding: 8px 0 0;
  } */
  .breadCrumbsWrapper {
    padding: 14px;
  }
  .login-wrapper {
    padding: 12px;
  }
  .bgPage {
    background: #000;
  }
}
</style>
